var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.5V11a9 9 0 019-9 9 9 0 019 9v4.5h1.125a5.623 5.623 0 015.625 5.625v11.25A5.623 5.623 0 0130.125 38H9.875a5.624 5.624 0 01-5.625-5.625v-11.25A5.624 5.624 0 019.875 15.5H11zm2.25 0h13.5V11A6.75 6.75 0 0020 4.25c-3.79 0-6.75 3.022-6.75 6.75v4.5zM6.5 32.375a3.375 3.375 0 003.375 3.375h20.25a3.376 3.376 0 003.375-3.375v-11.25a3.376 3.376 0 00-3.375-3.375H9.875A3.375 3.375 0 006.5 21.125v11.25z"
  })));
}
export default SvgLockLight;